const SHARED_ROUTES = {
  AGE_VERIFICATION_GATE: '/age-verification-gate',
  ALL_PRODUCTS_SEARCH: '/products',
  CNAME: '/[cName]',
  CNAME_INFO: '/[cName]/info',
  CHECKOUT: '/checkout',
  CITIES: '/cities',
  BRANDS: '/brands',
  DISPENSARY: '/dispensary',
  DISPENSARIES: '/dispensaries',
  DEMO: '/demo',
  EMBEDDED_MENU: '/embedded-menu',
  EMBEDDED_MENU_CNAME: '/embedded-menu/[cName]',
  INFO: '/info',
  KIOSKS: '/kiosks',
  KIOSKS_CNAME: '/kiosks/[cName]',
  MOBILE_ECOMM: '/mobile-ecomm',
  MOBILE_ECOMM_CNAME: '/mobile-ecomm/[cName]',
  OFFER: '/offer',
  OFFER_SPECIAL_ID: '/offer/[specialId]',
  PRODUCT: '/product/',
  PRODUCTS: '/products/',
  PRODUCT_ID: '/product/[productId]',
  SALE: '/sale',
  SALE_SPECIAL_ID: '/sale/[specialId]',
  SHOP: '/shop',
  SPECIALS: '/specials',
  STORES: '/stores',
  STORES_CNAME: '/stores/[cName]',
  SUBCATEGORY: '/products/[category]/[subcategory]',
};

export default SHARED_ROUTES;
